'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var unserialize = function unserialize(payload) {
  if (typeof payload === 'undefined') return null;
  return JSON.parse(payload);
};

var LocalStoragePersistence = function () {
  function LocalStoragePersistence(localStorage) {
    _classCallCheck(this, LocalStoragePersistence);

    this.localStorage = localStorage;
  }

  _createClass(LocalStoragePersistence, [{
    key: 'get',
    value: function get(key) {
      var stored = this.localStorage.getItem(key);
      if (!stored) return stored;
      try {
        return unserialize(stored);
      } catch (e) {
        // TODO apply the silent errorHandler here when the silent error handler has been added.
        return null;
      }
    }
  }, {
    key: 'set',
    value: function set(key, value) {
      this.localStorage.setItem(key, JSON.stringify(value));
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.localStorage.clear();
    }
  }]);

  return LocalStoragePersistence;
}();

exports.default = LocalStoragePersistence;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/services/LocalStorage.js
// module id = 1229
// module chunks = 0